import axios from 'axios';
import getApiBaseUrl from '../GetServer';

// Interface for the request payload, matching the backend's UpdateBlogStatusRequest
interface UpdateBlogStatusRequest {
    Id: number;
    Status: number;
}

// Interface for the expected backend response
interface BackendResponse {
    status: number;
    message: string;
}


export const changeBlogStatus = async (payload: UpdateBlogStatusRequest): Promise<BackendResponse> => {
    try {
        const baseUrl = getApiBaseUrl();
        const endpoint = `${baseUrl}dash/update-blog-status`;

        const token = localStorage.getItem('token');

        if (!token) {
            throw new Error('Token de autorización no disponible');
        }

        const response = await axios.post<BackendResponse>(endpoint, payload, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        if (response.data.status !== 200) {
            throw new Error(response.data.message || 'Error desconocido al cambiar el estado del blog');
        }

        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message || 'Error al conectar con el servidor');
        }
        throw error;
    }
};

